<label class="label" for="input-birthdate">
  <ng-container i18n="@@shared.giverProfile.input.birthdate">Geburtsdatum</ng-container>
  <abbr class="req-label" i18n-title="@@main.alt.required" title="Pflicht">*</abbr>
</label>
<div [class]="valueControl.invalid && (valueControl.touched || valueControl.dirty) ? 'ng-invalid' : ''"
  class="input-group-selectors">
  <ng-select [clearable]="false"
    [formControl]="birthdateDayControl"
    [items]="availableDays"
    appAddIconChevronDown
    bindValue="key"
    class="day"
    i18n-notFoundText="@@shared.placeholder.notFound"
    i18n-placeholder="@@shared.giverProfile.placeholder.day"
    labelForId="input-day"
    notFoundText="Keine Elemente gefunden"
    placeholder="Tag"
    >
  </ng-select>
  <ng-select [clearable]="false"
    [formControl]="birthdateMonthControl"
    [items]="availableMonths"
    appAddIconChevronDown
    bindValue="key"
    i18n-notFoundText="@@shared.placeholder.notFound"
    i18n-placeholder="@@shared.giverProfile.placeholder.month"
    labelForId="input-month"
    notFoundText="Keine Elemente gefunden"
    placeholder="Monat"
    >
    <ng-template let-item="item" ng-label-tmp>
      {{ item.label.split('|')[0] }}
    </ng-template>
    <ng-template let-index="index" let-item="item" ng-option-tmp>
      {{ item.label.split('|')[0] }}
    </ng-template>
  </ng-select>
  <ng-select [clearable]="false"
    [formControl]="birthdateYearControl"
    [items]="availableYears"
    appAddIconChevronDown
    bindValue="key"
    class="year"
    i18n-notFoundText="@@shared.placeholder.notFound"
    i18n-placeholder="@@shared.giverProfile.placeholder.year"
    labelForId="input-year"
    notFoundText="Keine Elemente gefunden"
    placeholder="Jahr"
    >
  </ng-select>
</div>
@if (valueControl.invalid && (valueControl.touched || valueControl.dirty)) {
  <div>
    @if (valueControl.errors.allowedAge) {
      <div
        class="validation error" i18n="@@shared.giverProfile.error.birthdateMin18">Du musst mindestens 18 Jahre alt
        sein
    </div>
    }
    @if (valueControl.errors.pattern) {
      <div
        class="validation error" i18n="@@shared.giverProfile.error.birthdateFormat">Das Datum muss im Format JJJJ-MM-DD
        eingegeben werden.
    </div>
    }
  </div>
}
